<template>
  <div class="list-escrow-officers">
    <h2>Escrow Officer</h2>
    <hr/>
    <p>Please provide escrow information if known.</p>
    
    <template v-if="!showAddNewOfficer && hasContacts">
      <b-form-group label="Escrow Officer" label-for="escrow-officer-select">
        <b-form-select
          id="escrow-officer-select"
          v-model="selectedOfficer"
          :options="officerOptions"
          @change="handleOfficerSelection"
        >
          <template #first>
            <b-form-select-option :value="null">Select Escrow Officer</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>
      
      <p class="text-muted">Select which escrow officer will manage the closing.</p>
      
      <b-button class="white-button" @click="showAddNewOfficer = true">
        Add New Escrow Officer
      </b-button>
    </template>
    
    <template v-else>
      <AddEscrowOfficers @add-new-escrow-officer="addNewEscrowOfficerHandler" ref="addEscrowOfficers"/>
    </template>
  </div>
</template>

<script>
import './EscrowOfficers.scss';
import AddEscrowOfficers from './AddEscrowOfficers.vue';
import { mapState } from 'pinia';
import { useAuthStore } from '@store';
import { AppResourceSearch, ApiFilter } from '@sellers-shield-home-protection/ss-core-js';

export default {
  name: 'ListEscrowOfficers',
  components: {
    AddEscrowOfficers
  },
  props:{
    agentUuid:{
      type: String,
      require: false
    }
  },
  data() {
    return {
      selectedOfficer: null,
      showAddNewOfficer: false,
      localContacts: [],
      contactAppResourceSearch: new AppResourceSearch('contact'),
      loading: false
    };
  },
  computed: {
    ...mapState(useAuthStore, {
      me: 'me',
    }),
    officerOptions() {
      return this.localContacts.map(contact => ({
        value: contact.uuid,
        text: `${contact.fullName}`
      }));
    },
    hasContacts() {
      return this.localContacts.length > 0;
    }
  },
  methods: {
    async fetchContacts() {
      this.loading = true;
      try {
        const searchData = {
          filter: new ApiFilter({
            params: {
              userUuid: this.agentUuid ?? this.me.uuid,
              contactTypeId: 11010
            },
          }),
        };

        await this.contactAppResourceSearch.setSearchData(searchData);
        await this.contactAppResourceSearch.search();
        this.localContacts = this.contactAppResourceSearch.appResourceCollection.toArray();
        
        //Making sure that contacts list will be updated right after fetch to decide if to show add new officer button or not
        this.showAddNewOfficer = !this.hasContacts;
      } catch (error) {
        console.error('Error fetching contacts:', error);
      } finally {
        this.loading = false;
      }
    },
    handleOfficerSelection(value) {
      const selectedContact = this.localContacts.find(contact => contact.uuid === value);
      if (selectedContact) {
        this.$emit('officerSelected', {
          id: selectedContact.uuid,
          fullName: selectedContact.fullName,
          email: selectedContact.email,
          companyName: selectedContact.companyName || ''
        });
      }
    },
    async handleNewOfficerAdded() {
      // Here you would typically add the new officer to your contacts list
      // For now, we'll just emit the new officer info to the parent

      // this.$emit('officerAdded', newOfficerInfo);
      let contact = null;
      if(this.showAddNewOfficer){
        contact = await this.$refs.addEscrowOfficers.submitEscrowInfo();
      }
      return contact;
    },
    addNewEscrowOfficerHandler(escrowInfo){
      this.$emit('add-new-escrow-officer', escrowInfo)
    }
  },
  created() {
    this.fetchContacts();
  }
}
</script>